import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#1c1c1c",
  viewBox: "0 0 14.071 8.56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9.781 0 8.72 1.06l2.47 2.471H0v1.5h11.188L8.72 7.5l1.062 1.06c1.433-1.423 2.848-2.865 4.29-4.279C12.634 2.863 11.211 1.428 9.782 0z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow2"}) } }